module.exports={
   //  URL : 'https://tservofc2.exceloid.com/etestresource-server/' // test // https://ofd-test.mycw.in/#/system/login
   // URL :'https://loyaltyapi.organicfoodsandcafe.com:8443/resource-server/' // live // https://ofd-aag.mycw.in/#/system/login
    URL :"https://jinzo.mycw.in:8443/resource-server/swagger-ui.html/"  // jinzo live // ofd-jinzo.mycw.in
} 